module.exports = __webpack_public_path__ + "img/house_23.75bcf093.jpg";